import { render, staticRenderFns } from "./TicketHeader.vue?vue&type=template&id=36ece1b3&scoped=true&"
import script from "./TicketHeader.vue?vue&type=script&lang=ts&"
export * from "./TicketHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ece1b3",
  null
  
)

export default component.exports